<div class="login-form login-view-3">
  <h3 class="login-form-header">{{ 'login.expired_token_title' | translate }}</h3>
  <div class="login-form-bodySend">
    <span>{{ 'login.expired_token_body' | translate }}</span>
  </div>
  <div class="login-button-container">
    <app-button type="button" [label]="'login.connect'" (click)="done.emit()"></app-button>
  </div>
</div>
